export default __webpack_public_path__ + "fd1730c844269985290f8073ffce6d08.svg";